module.exports = __webpack_public_path__ + "static/media/hgf.da926b8f.png";